function Tracksku({ loading, Skeleton, selectedSize }) {

  return (

    <p className="id_tracker" style={{ marginBottom: "0" }}>
      {loading ? (
        <Skeleton width={100} />
      ) : (
        `SKU: ${selectedSize?.sku}`
      )}
    </p>
  )

}

export default Tracksku;